import { render } from "./education-details.vue?vue&type=template&id=4725253b&scoped=true"
import script from "./education-details.vue?vue&type=script&lang=js"
export * from "./education-details.vue?vue&type=script&lang=js"

import "./education-details.vue?vue&type=style&index=0&id=4725253b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4725253b"]])

export default __exports__